export default function ParticipantInfo({ name, role, avatar }) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-full bg-primary-gradient flex items-center justify-center text-white font-bold text-lg">
        {avatar || name.charAt(0).toUpperCase()}
      </div>
      <div className="flex flex-col">
        <div className="text-white font-semibold text-[0.95rem]">{name}</div>
        {/* <div className="text-text-secondary text-xs uppercase tracking-wider">{role}</div> */}
      </div>
    </div>
  )
}
